import React from 'react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { BusinessGroup } from './types';
import { useModal } from '../../global-hooks';
import { UI_MODALS } from '../../../helpers/enums';
import ColorButton from '../../common/buttons/color-button';

interface BusinessGroupItemProps {
  group: BusinessGroup;
  onUpdateSuccess(): void;
}

const BusinessGroupItem: React.FC<BusinessGroupItemProps> = ({ group, onUpdateSuccess }) => {
  const { t } = useTranslation();
  const { initModal } = useModal();

  const handleEdit = () => {
    initModal(UI_MODALS.BUSINESS_GROUP, {
      id: group.id,
      onSuccess: () => {
        onUpdateSuccess();
      }
    });
  };

  const handleView = () => {
    initModal(UI_MODALS.BUSINESS_GROUP_CLUBS, {
      id: group.id
    });
  };

  return (
    <div className="flex flex-row p-4 w-full hover:bg-gray-800 border-b-2 border-gray-800 last:border-b-0">
      <div className="flex flex-col flex-grow">
        <div className="flex items-center justify-between">
          <div>
            <div className="font-bold text-xl">{group.name}</div>
            <div className="text-gray-300 mt-1">
              <span>Created: {group.created_at ? format(new Date(group.created_at), 'MMM dd, yyyy') : 'Unknown'}</span>
              <span className="ml-4">Updated: {group.updated_at ? format(new Date(group.updated_at), 'MMM dd, yyyy') : 'Unknown'}</span>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <ColorButton color={'blue'} type={'inverted'} className='w-24' onClick={handleEdit}>
              {t('common.edit')}
            </ColorButton>
            <ColorButton color={'blue'} type={'inverted'} className='w-24 ml-5' onClick={handleView}>
              {t('common.view')}
            </ColorButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessGroupItem;
